export default __webpack_public_path__ + "370b981c630612f7e8143f553fe32d48.svg";